import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ExternalCalendarInformationOutput } from 'user/model/external-calendar-information.output';
import { UserNetworkType } from 'user/model/user-network.type';

import { ApiQuery } from '../../../../common/model/api.query';

export interface UserExternalCalendarParams {
	readonly type: UserNetworkType;
}

@Injectable({ providedIn: 'root' })
export class UserExternalCalendarApiQuery extends ApiQuery<
	ExternalCalendarInformationOutput[],
	UserExternalCalendarParams
> {
	client = 'iam';
	document = gql`
		query UserExternalCalendars($type: UserNetworkType!) {
			userExternalCalendars(type: $type) {
				isDefaultCalendar
				isSelected
				externalCalendarId
				externalCalendarName
			}
		}
	`;
	method = 'userExternalCalendars';
}
